import React from 'react';
import PropTypes from 'prop-types';
import './ContactAssistance.scss';

const SUPPORT_EMAIL = 'sandos4u.mx@sandos.com';

const ContactAssistance = ({ className }, context) => (
  <div className={`contact-assistance ${className || ''}`}>
    <p>{context.t('Do you need assistance?')}</p>
    <a href={`mailto:${SUPPORT_EMAIL}`}>{context.t('Contact us')}</a>
  </div>
);

ContactAssistance.propTypes = {
  className: PropTypes.string,
};

ContactAssistance.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ContactAssistance;
